import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/event/importer/eventImporterActions';

export default importerReducers(actions);
